import { useDataChange } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
  })
  return function onChange(value) {
    change(next => {
      next.data.sms = value
      next.data.sms_template = {
        ...next.data.sms_template,
        enabled: true,
      }
    })
  }
}
